import AgencyList from '@/components/Agency/AgencyList'
import AgencyForm from '@/components/Agency/AgencyForm'
import AgencyDetail from '@/components/Agency/AgencyDetail'

let AgencyRouter = [{
  path: '/agency',
  name: 'AgencyList',
  component: AgencyList,
  meta: {
    title: 'Agences',
    requiresAuth: true,
    authorizations: ['agency_index', 'desktop_access']
  }
}, {
  path: '/agency/new',
  name: 'AgencyNew',
  component: AgencyForm,
  meta: {
    title: 'Nouvelle agence',
    requiresAuth: true,
    authorizations: ['agency_new', 'desktop_access']
  }
}, {
  path: '/agency/:id/edit',
  name: 'AgencyEdit',
  component: AgencyForm,
  meta: {
    title: 'Modifier une agence',
    requiresAuth: true,
    authorizations: ['agency_edit', 'desktop_access']
  }
}, {
  path: '/agency/:id',
  name: 'AgencyDetail',
  component: AgencyDetail,
  meta: {
    title: 'Fiche agence',
    requiresAuth: true,
    authorizations: ['agency_show', 'desktop_access']
  }
}]

export default AgencyRouter



// WEBPACK FOOTER //
// ./src/components/Agency/router.js